var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<product-list-viewer product-list-id=\"$ctrl.productListId\" simple=\"true\" lists-route=\"consumer.lists\"></product-list-viewer>";
var id1="consumer-list.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;